import React, { useState, useEffect } from "react";
import {
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  Checkbox,
} from "@mui/material";
import Sidebar from "./Sidebar";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

const CommunityManagement = () => {
  const [selectedCommunityFeed, setSelectedCommunityFeed] = useState(null);
  const [totalItems, setTotalItems] = useState(0);
  const usersPerPage = 8;
  const [currentPage, setCurrentPage] = useState(1);
  const [communityList, setCommunityList] = useState([]);

  useEffect(() => {
    fetchComminityFeed();
  }, [currentPage]);

  //http://localhost:8080/community-feeds?page={pno}&size={size}&cid={cid}&city={city}

  const fetchComminityFeed = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `https://yelospace.com/api/community-feeds?page=${
          currentPage - 1
        }&size=${usersPerPage}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCommunityList(response?.data?.response);
      setTotalItems(response?.data?.response?.totalItems || 0);
    } catch (error) {
      console.error("Error fetching property details:", error);
    }
  };

  //http://localhost:8080/community-feed/delete/{communityFeedId}

  const deleteProperty = async (communityFeedId) => {
    try {
      const token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      await axios.post(
        `https://yelospace.com/api/community-feed/delete/${communityFeedId}`,
        null,
        { headers }
      );
      fetchComminityFeed();
      setSelectedCommunityFeed(null);
      //console.log"Community Post Deleted Successfully");
      toast.success("Community Post Deleted Successfully");
    } catch (error) {
      console.error("Error deleting community post:", error);
    }
  };

  const handleCheckboxChange = (communityFeedId) => {
    if (selectedCommunityFeed === communityFeedId) {
      setSelectedCommunityFeed(null);
    } else {
      setSelectedCommunityFeed(communityFeedId);
    }
  };
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    //console.log"communityList>>>", communityList);
  }, [communityList]);

  return (
    <Container style={{ display: "flex", marginTop: "20px" }}>
      <ToastContainer />
      <Sidebar />

      <div style={{ flex: "1", marginLeft: "10vw" }}>
        <Typography
          variant="h6"
          style={{
            color: "#F5C000",
            fontWeight: "bold",
            marginBottom: "12px",
            marginTop: "24px",
          }}
        >
          Community Management
        </Typography>
        <Paper
          elevation={0}
          style={{ width: "100%", border: "1px solid #fee9c5" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px",
              borderBottom: "1px solid #F5C000",
            }}
          >
            <Typography variant="body1" component="p">
              Posts ({totalItems})
            </Typography>
            <div style={{ display: "flex" }}>
              <Button
                onClick={() => deleteProperty(selectedCommunityFeed)}
                variant="contained"
                style={{
                  color: "#000",
                  borderRadius: "12px",
                  backgroundColor: "#F5C000",
                  boxShadow: "none",
                  border: "1px solid #F5C000",
                }}
              >
                Delete
              </Button>
            </div>
          </div>

          <TableContainer>
            <Table style={{ border: "1.5px solid #fee9c5" }}>
              <TableHead>
                <TableRow style={{ borderBottom: "1.5px solid #fee9c5" }}>
                  <TableCell></TableCell>
                  <TableCell>
                    <b>Name</b>
                  </TableCell>
                  <TableCell>
                    <b>Email</b>
                  </TableCell>
                  <TableCell>
                    <b>Mobile</b>
                  </TableCell>
                  <TableCell>
                    <b>City</b>
                  </TableCell>
                  <TableCell>
                    <b>State</b>
                  </TableCell>
                  <TableCell>
                    <b>Description</b>
                  </TableCell>
                  <TableCell>
                    <b>Category</b>
                  </TableCell>
                  <TableCell>
                    <b>Media</b>
                  </TableCell>
                  <TableCell>
                    <b>Role</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {communityList?.communityFeeds?.map((row) => (
                  <TableRow
                    key={row.id}
                    style={{ borderBottom: "1.5px solid #fee9c5" }}
                  >
                    <TableCell>
                      <Checkbox
                        checked={selectedCommunityFeed === row?.communityFeedId}
                        onChange={() =>
                          handleCheckboxChange(row?.communityFeedId)
                        }
                        style={{ color: "#F5C000" }}
                      />{" "}
                      {/* Row Checkbox */}
                    </TableCell>
                    <TableCell>{row?.user?.firstName}</TableCell>
                    <TableCell>{row?.user?.email}</TableCell>
                    <TableCell>{row?.user?.mobile}</TableCell>
                    <TableCell>{row.city}</TableCell>
                    <TableCell>{row.state}</TableCell>
                    <TableCell>{row.description}</TableCell>
                    <TableCell>{row.categoryName}</TableCell>
                    <TableCell>
                      {row?.communityFeedMedia?.map((media) => (
                        <div key={media.id}>
                          <a
                            href={media.url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {media.fileName}{" "}
                          </a>
                        </div>
                      ))}
                    </TableCell>
                    {row?.user?.role ? (
                      <TableCell>{row?.user?.role}</TableCell>
                    ) : (
                      <TableCell>PROVIDER</TableCell>
                    )}
                    {/* <TableCell>{row?.user?.role}</TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        {/* Pagination */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          {[...Array(Math.ceil(totalItems / usersPerPage))].map((_, index) => (
            <Button
              key={index}
              variant="contained"
              style={{
                borderRadius: "20px",
                marginRight: "5px",
                backgroundColor:
                  currentPage === index + 1 ? "#5F5F61" : "white",
                color: currentPage === index + 1 ? "white" : "#5F5F61",
              }}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </Button>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default CommunityManagement;
